module.exports = __webpack_public_path__ + "img/ex15.fd4fb80e.png";